import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';
import { AxiosInstance, AxiosPromise } from 'axios';
import {
  SearchLanesRequest,
  SearchLanesResponse,
  GetLaneRequest,
  GetLaneResponse,
  CreateLaneRequest,
  CreateLaneResponse,
  UpdateLaneRequest,
  UpdateLaneResponse,
  DeleteLaneRequest,
  DeleteLaneResponse,
  SearchUserLanesRequest,
  SearchUserLanesResponse,
  CreateUserLaneRequest,
  CreateUserLaneResponse,
  DeleteUserLaneRequest,
  DeleteUserLaneResponse,
} from './LaneService.types';

export class LaneService implements BaseRequestEndpoints {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search(request: SearchLanesRequest) {
    return this.instance.get<SearchLanesResponse>('/lanes', {
      params: request.queryParams,
    });
  }

  getById(request: GetLaneRequest) {
    return this.instance.get<GetLaneResponse>(`/lanes/${request.routeParams.id}`);
  }

  create(request: CreateLaneRequest) {
    return this.instance.post<CreateLaneResponse>('/lanes', request.body);
  }

  update(request: UpdateLaneRequest) {
    return this.instance.patch<UpdateLaneResponse>(
      `/lanes/${request.routeParams.id}`,
      request.body,
    );
  }

  delete(request: DeleteLaneRequest): AxiosPromise<DeleteLaneResponse> {
    return this.instance.delete(`/lanes/${request.routeParams.id}`);
  }

  // User Lane Assignments
  searchUserLanes(request: SearchUserLanesRequest) {
    return this.instance.get<SearchUserLanesResponse>(
      `/lanes/${request.routeParams.laneId}/assignments`,
      {
        params: request.queryParams,
      },
    );
  }

  createUserLane(request: CreateUserLaneRequest) {
    return this.instance.post<CreateUserLaneResponse>(
      `/lanes/${request.routeParams.laneId}/assignments`,
      request.body,
    );
  }

  deleteUserLane(request: DeleteUserLaneRequest): AxiosPromise<DeleteUserLaneResponse> {
    return this.instance.delete(
      `/lanes/${request.routeParams.laneId}/assignments/${request.routeParams.assignmentId}`,
    );
  }
}
